import * as actions from './profile.actions';

export interface State {
    profileImageId: string;
}

export const initialState: State = {
    profileImageId: undefined,
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {


    default:
      return state;
  }
}
